export default "__VITE_ASSET__d1xJT9Mf__"